module.exports = __webpack_public_path__ + "static/media/galeryAbout4.7745da4b.jpg";